import type { MutationTree } from 'vuex';
import type { DocumentPage } from '@getaccept/lib-shared/src/types/document-page';
import { TrackingMutation } from './tracking.constants';
import type { TrackingState } from './tracking.types';

export const mutations: MutationTree<TrackingState> = {
  [TrackingMutation.SetCurrentDocumentPages](state: TrackingState, pages: DocumentPage[]) {
    state.currentDocumentPages = pages;
  },
  [TrackingMutation.SetPageViewStopWatchPaused](state: TrackingState, paused: boolean) {
    state.pageViewStopWatchPaused = paused;
  },
  [TrackingMutation.SetSuspendPageTracking](state: TrackingState, suspend: boolean) {
    state.suspendPageTracking = suspend;
  },
  [TrackingMutation.SetTrackingDisabled](state: TrackingState, disabled: boolean) {
    state.trackingDisabled = disabled;
  },
};
